import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { ARTICLES } from "@/lib/articles";

export const EducationCenter = () => (
  <section data-testid="education-center-section" className="bg-[#141419] py-14 lg:py-20">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="text-[11px] font-bold uppercase tracking-[0.24em] text-[#D8B54A]" data-testid="education-center-label">
              Education Center
            </p>
            <h2
              data-testid="education-center-heading"
              className="mt-3 font-heading text-2xl font-bold tracking-tight text-[#F2EEE3] sm:text-3xl lg:text-4xl"
            >
              Learn Before You Apply.
            </h2>
          </div>
          <Link
            to="/education"
            data-testid="education-center-view-all"
            className="group inline-flex items-center gap-2 text-sm font-semibold text-[#D8B54A] transition-colors duration-200 hover:text-[#E4C463]"
          >
            View all educational resources
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
          </Link>
        </div>
      </Reveal>
      <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {ARTICLES.slice(0, 6).map((article, i) => (
          <Reveal key={article.slug} delay={i * 0.06}>
            <Link
              to={`/education/${article.slug}`}
              data-testid={`article-card-${article.slug}`}
              className="group flex h-full flex-col rounded-2xl border border-white/10 bg-[#17171C] p-7 transition-all duration-300 hover:-translate-y-1 hover:border-[#C9A227]/30 hover:shadow-xl hover:shadow-black/40"
            >
              <div className="flex items-start justify-between gap-4">
                <h3 className="font-heading text-lg font-semibold tracking-tight text-[#F2EEE3] transition-colors duration-200 group-hover:text-[#D8B54A]">
                  {article.title}
                </h3>
                <ArrowUpRight className="h-5 w-5 shrink-0 text-[#C6C0B4] transition-colors duration-200 group-hover:text-[#D8B54A]" />
              </div>
              <p className="mt-3 text-sm leading-relaxed text-[#B8B2A6]">{article.description}</p>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
